export default {
  all: null,
  pharmaciesVectorLayer: undefined,
  styleCachePharmacy: [],
  pharmacies: null,
};
